import Agent from 'agentkeepalive';
import axios from 'axios';

const createHttpAgent = () => {
    return new Agent({
        maxSockets: 100,
        maxFreeSockets: 10,
        timeout: 60000,
        freeSocketTimeout: 30000,
    });
};

const createHttpsAgent = () => {
    return new Agent.HttpsAgent({
        maxSockets: 100,
        maxFreeSockets: 100,
        timeout: 60000,
        freeSocketTimeout: 30000,
    });
};

const configureHttp = () => {
    axios.defaults.httpAgent = createHttpAgent();
    axios.defaults.httpsAgent = createHttpsAgent();
};

export default configureHttp;
